import './Logo.scss';

type LogoProps = {
    size?: string,
};

function Logo(props: LogoProps) {

    const sizeWH = props.size ?? '1rem';
    return (
        <div className="lumeba-logo" style={{width: sizeWH, height: sizeWH}}></div>
    );
}

export default Logo;
